
// 业务页面路由配置
import { lazy } from "react";
import { IRoute } from "@src/Model/IRoute";

export const PCProductRoutes: IRoute[] = [
    {
        path: "/:lang/product/efficient",
        Component: lazy(() => import("@src/Pages/CN/PC/Efficient")),
    },
    {
        path: "/:lang/product/online-restaurant",
        Component: lazy(() => import("@src/Pages/CN/PC/OnlineRestaurant")),
    },
    {
        path: "/:lang/product/marketing",
        Component: lazy(() => import("@src/Pages/CN/PC/Marketing")),
    },
    {
        path: "/:lang/product/supply-chain",
        Component: lazy(() => import("@src/Pages/CN/PC/SupplyChain")),
    },
    {
        path: "/:lang/product/manage-decision",
        Component: lazy(() => import("@src/Pages/CN/PC/ManageDecision")),
    },
    {
        path: "/:lang/product/chain-control",
        Component: lazy(() => import("@src/Pages/CN/PC/ChainControl")),
    },
];

export const MobileProductRoutes: IRoute[] = [
    {
        path: "/:lang/product/efficient",
        Component: lazy(() => import("@src/Pages/CN/Mobile/Product/Efficient")),
    },
    {
        path: "/:lang/product/online-restaurant",
        Component: lazy(() => import("@src/Pages/CN/Mobile/Product/OnlineRestaurant")),
    },
    {
        path: "/:lang/product/marketing",
        Component: lazy(() => import("@src/Pages/CN/Mobile/Product/Marketing")),
    },
    {
        path: "/:lang/product/supply-chain",
        Component: lazy(() => import("@src/Pages/CN/Mobile/Product/SupplyChain")),
    },
    {
        path: "/:lang/product/manage-decision",
        Component: lazy(() => import("@src/Pages/CN/Mobile/Product/ManageDecision")),
    },
    {
        path: "/:lang/product/chain-control",
        Component: lazy(() => import("@src/Pages/CN/Mobile/Product/ChainControl")),
    }
];
